/* eslint-disable */

import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export const store = new Vuex.Store({ 
    state: {
        filesAdd: [],
        token: 0,
        anotherVar: '',
        locationMain: true,
        locationAdd: false,
        locationsArrow: null,
        locationsEdite: null,
        statusesArrow: null,
        AddHeader: 'ДОБАВИТЬ ОБЪЕКТ',
        objectVisibleMain: true,
        objectVisibleAdd: false,
        objectsArrow: null,
        objectEdite: null,
        objectInfo: null,
        objectAdd: false,
        bookingArrow: [],
        staffVisibleMain: true,
        staffVisibleAdd: false,
        partnersVisibleMain: true,
        partnersVisibleAdd: false,
        partnersArrow: {
            current_page: 0,
            data: null,
            total_pages: 0
        },
        carpVisibleMain: true,
        carpVisibleAdd: false,
        carpArrow: {
            current_page: 0,
            data: null,
            total_pages: 0
        },
        carpArrowOne: null,
        staffArrow: null,
        staffEdite: null,
        staffAdd: false,
        partnersEdite: null,
        partnerArrow: null,
        partnersAdd: false,
        carpEdite: null,
        carpAdd: false,
        profile: {
            avatar: null,
            email: null,
            id: 0,
            phone: null,
            position: null,
            role: {
                code: null,
                id: null,
                name: null
            },
            user: {
                id: null,
                name: null,
                phone: null
            },
            accounting: {
                "view": null,
                "add": false,
                "edit": false,
                "delete": false
            },
            reservations: {
                "view": null,
                "add": false,
                "edit": false,
                "delete": false
            },
            objects: {
                "view": null,
                "add": false,
                "edit": false,
                "delete": false
            },
            corporates: {
                "view": null,
                "add": false,
                "edit": false,
                "delete": false
            },
            partners: {
                "view": null,
                "add": false,
                "edit": false,
                "delete": false
            },
            applications: {
                "view": null,
                "add": false,
                "edit": false,
                "delete": false
            }
        },
        updateActive: false
    },
    mutations: {
        filesAdd(state, value) {
            state.filesAdd = value;
        },
        setToken(state, value) {
            state.token = value;
        },
        sendToken() {
            return state.token
        },
        setAnotherVar(state, value) {
            state.anotherVar = value
        },
        logout(state){
            state.token = ''
            state.anotherVar = ''
        },
        locationMain(state){
            state.locationMain = true
            state.locationAdd = false
        },
        locationAdd(state){
            state.locationMain = false
            state.locationAdd = true
        },
        locationsArrow(state, data) {
            state.locationsArrow = data
        },
        locationsEdite(state, data) {
            state.locationsEdite = data
        },
        statusesArrow(state, data) {
            state.statusesArrow = data
        },
        AddHeader(state, data){
            state.AddHeader = data
        },
        objectVisibleMain(state){
            state.objectVisibleMain = true
            state.objectVisibleAdd = false
        },
        objectVisibleAdd(state){
            state.objectVisibleMain = false
            state.objectVisibleAdd = true
        },
        objectsArrow(state, data){
            state.objectsArrow = data
        },
        objectInfo(state, data){
            state.objectInfo = data
        },
        objectEdite(state, data){
            state.objectEdite = data
        },
        objectAdd(state, data){
            state.objectAdd = data
        },
        bookingArrow(state, data){
            state.bookingArrow = data
        },
        staffVisibleMain(state){
            state.staffVisibleMain = true
            state.staffVisibleAdd = false
        },
        staffVisibleAdd(state){
            state.staffVisibleMain = false
            state.staffVisibleAdd = true
        },
        partnersVisibleMain(state){
            state.partnersVisibleMain = true
            state.partnersVisibleAdd = false
        },
        partnersVisibleAdd(state){
            state.partnersVisibleMain = false
            state.partnersVisibleAdd = true
        },
        partnersArrow(state, data){
            state.partnersArrow = data
        },
        carpVisibleMain(state){
            state.carpVisibleMain = true
            state.carpVisibleAdd = false
        },
        carpVisibleAdd(state){
            state.carpVisibleMain = false
            state.carpVisibleAdd = true
        },
        carpArrow(state, data){
            state.carpArrow = data
        },
        carpArrowOne(state, data){
            state.carpArrowOne = data
        },
        staffArrow(state, data){
            state.staffArrow = data
        },
        staffEdite(state, data){
            state.staffEdite = data
        },
        staffAdd(state, data){
            state.staffAdd = data
        },
        partnerArrow(state, data){
            state.partnerArrow = data
        },
        partnersEdite(state, data){
            state.partnersEdite = data
        },
        partnersAdd(state, data){
            state.partnersAdd = data
        },
        carpEdite(state, data){
            state.carpEdite = data
        },
        carpAdd(state, data){
            state.carpAdd = data
        },
        carpAdd(state, data){
            state.carpAdd = data
        },
        profileAdd(state, data){
            state.profile = data
        },
        updateActive(state, data) {
            state.updateActive = data
        }
    },
    getters: {
        filesAdd: state => state.filesAdd,
        token: state => state.token,
        anotherVar: state => state.anotherVar,
        locationMain: state => state.locationMain,
        locationAdd: state => state.locationAdd,
        locationsArrow: state => state.locationsArrow,
        locationsEdite: state => state.locationAdd,
        statusesArrow: state => state.statusesArrow,
        objectVisibleMain: state => state.objectVisibleMain,
        AddHeader: state => state.AddHeader,
        objectVisibleAdd: state => state.objectVisibleAdd,
        objectsArrow: state => state.objectsArrow,
        objectInfo: state => state.objectInfo,
        objectEdite: state => state.objectEdite,
        objectAdd: state => state.objectAdd,
        bookingArrow: state => state.bookingArrow,
        staffVisibleMain: state => state.staffVisibleMain,
        staffVisibleAdd: state => state.staffVisibleAdd,
        partnersVisibleMain: state => state.partnersVisibleMain,
        partnersVisibleAdd: state => state.partnersVisibleAdd,
        partnersArrow: state => state.partnersArrow,
        carpVisibleMain: state => state.carpVisibleMain,
        carpVisibleAdd: state => state.carpVisibleAdd,
        carpArrow: state => state.carpArrow,
        carpArrowOne: state => state.carpArrowOne,
        staffArrow: state => state.staffArrow,
        staffEdite: state => state.staffEdite,
        staffAdd: state => state.staffAdd,
        partnerArrow: state => state.partnerArrow,
        partnersEdite: state => state.partnersEdite,
        partnersAdd: state => state.partnersAdd,
        carpEdite: state => state.carpEdite,
        carpAdd: state => state.carpAdd,
        profileAdd: state => state.profile,
        updateActive: state => state.updateActive
    }
})


// WEBPACK FOOTER //
// ./src/store/store.js